'use client';
import { createStyles, rem, getSize, keyframes } from '@s7/styles';

const animationStart = keyframes`                
    0% {
        clip-path: polygon(50% 50%,0 0,50% 0%,50% 0%,50% 0%,50% 0%,50% 0%);
    }
    12.5% {
        clip-path: polygon(50% 50%,0 0,50% 0%,100% 0%,100% 0%,100% 0%,100% 0%);
    }
    25% {
        clip-path: polygon(50% 50%,0 0,50% 0%,100% 0%,100% 100%,100% 100%,100% 100%);
    }
    50% {
        clip-path: polygon(50% 50%,0 0,50% 0%,100% 0%,100% 100%,50% 100%,0% 100%);
    }
    62.5% {
        clip-path: polygon(50% 50%,100%  0,100% 0%,100% 0%,100% 100%,50% 100%,0% 100%);
    }
    75% {
        clip-path: polygon(50% 50%,100% 100%,100% 100%,100% 100%,100% 100%,50% 100%,0% 100%);
    }
    100% {
        clip-path: polygon(50% 50%,50% 100%,50% 100%,50% 100%,50% 100%,50% 100%,0% 100%);
    }
`;
const animationEnd = keyframes`
    0% { 
        transform: scaleY(1)  rotate(0deg);
    }
    49.99% {
         transform: scaleY(1)  rotate(135deg);
    }
    50% { 
        transform: scaleY(-1) rotate(0deg);
    }
    100% { 
        transform: scaleY(-1) rotate(-135deg);
    }
`;
const sizes = {
    xl2: 60,
    xl1: 40,
    lg1: 32,
    md1: 20,
    sm1: 16
};
const borderWidths = {
    xl2: 5,
    xl1: 5,
    lg1: 4,
    md1: 3,
    sm1: 2
};
var useStyles = createStyles((theme, { color }, { size })=>{
    const _size = rem(getSize({
        size,
        sizes
    }));
    const base = color ? theme.fn.primaryShade(theme.fn.themeColor(color)) : 'currentColor';
    var _borderWidths_size;
    const borderWidth = rem((_borderWidths_size = borderWidths[size]) != null ? _borderWidths_size : borderWidths.md1);
    return {
        root: {
            boxSizing: 'border-box',
            width: _size,
            height: _size,
            borderRadius: '50%',
            border: `${borderWidth} solid ${base}`,
            backgroundColor: 'transparent !important',
            animation: `${animationStart} 0.8s infinite linear alternate, ${animationEnd} 1.6s infinite linear`
        }
    };
});

export { borderWidths, useStyles as default, sizes };
//# sourceMappingURL=Loader.styles.js.map
